import { type MotionProps, motion } from 'motion/react'
import { type ReactNode, useRef, useState } from 'react'

export function FadeInButton({
  delay,
  exit,
  className,
  onClick,
  children,
}: {
  delay: number
  exit?: MotionProps['exit']
  className?: string
  onClick?: () => void
  children: ReactNode
}) {
  const [ready, setReady] = useState(false)
  const clickedRef = useRef(false)

  return (
    <motion.button
      className={className}
      disabled={!ready}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={exit}
      transition={{ duration: 1, delay }}
      onAnimationComplete={() => setReady(true)}
      onClick={() => {
        if (clickedRef.current) return
        clickedRef.current = true
        onClick?.()
      }}
    >
      {children}
    </motion.button>
  )
}
